import React, { createContext } from 'react';
import { ParsedType } from './routerGenerator';

export const RouteContext = createContext<
  ParsedType & {
    onChangeBreadCrumbs?: (data: any) => void;
  }
>({
  menuList: [] as ParsedType['menuList'],
  routerList: [] as ParsedType['routerList'],
  breadcrumbData: {} as ParsedType['breadcrumbData'],
});

export function RouteProvider({ parsed, children }: { children: React.ReactNode; parsed: ParsedType }) {
  return <RouteContext.Provider value={parsed}>{children}</RouteContext.Provider>;
}

export default RouteProvider;
